<template>
  <bvue-ui-view class="flex flex-col">
    <h1>Transacciones</h1>
    <p>Pulsa en la fila para editar la transacción.</p>
    <!-- <button @click="revertPayments">Revertir pagos</button> -->
    <div class="flex-1 overflow-scroll relative">
      <sortable-table :items="items" :columns="columns" startSort="createdAt" startSortOrder="dec" @rowSelected="rowSelected"/>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import SortableTable from '@/components/SortableTable'
export default {
  name: 'Countries',
  data() {
    return {
      columns: [
        {
          key: 'createdAt',
          name: 'fecha',
          align: 'center',
          sortable: true,
          type: 'text',
          transform: (value) => {
            return new Date(value)
          }
        },
        {
          key: 'amount',
          name: 'amout',
          align: 'center',
          sortable: true,
          type: 'text',
          transform: (value) => {
            return value + ' $'
          }
        },
        {
          key: 'state',
          name: 'Estado',
          align: 'center',
          sortable: true,
          type: 'text',
          transform: (value) => {
            if (value === 'error') {
              return `<span class="text-red">${value}</span>`
            } else if (value === 'paid') {
              return `<span class="text-green">${value}</span>`
            } else if (value === 'unpaid') {
              return `<span class="text-blue">${value}</span>`
            } else if (value === 'removed') {
              return `<span class="text-orange">${value}</span>`
            } else if (value === 'refunded') {
              return `<span class="text-purple">${value}</span>`
            }
            return value
          }
        },
      ]
    }
  },
  components: {
    SortableTable
  },
  computed: {
    items() {
      return this.$store.state.transactions.items
    }
  },
  methods: {
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        this.$router.push('/admin/transactionDetail/'+item.id)
      }
    },
  //   async revertPayments() {
  //     console.log('start')
  //     var seeds = []
  //     var notSeeds = []
  //     const emptySeeds = this.$store.getters.reserveUnplantedSeeds('bIChzCan1TvVvhJYdYdX')
  //     var addedSeeds = []
  //     for (let i = 0; i < this.items.length; i++) {
  //       const item = this.items[i];
  //       // Lara: kSjKn1yyufaV1fNoLxOJDeS9hfs1
  //       // Adrian: x7DNeTiXVLefRSPOjaqLkqcDecu1
  //       if (item.userId != 'kSjKn1yyufaV1fNoLxOJDeS9hfs1' && item.userId != 'x7DNeTiXVLefRSPOjaqLkqcDecu1') {
  //         console.log('Transaction: ', item.id)
  //         // console.log('Fecha: ', new Date(item.createdAt))
  //         // console.log('usuario: ', item.userId)
  //         // const profile = (await firebase.firestore.collection('profiles').doc(item.userId).get()).data()
  //         // console.log('nombre: ', profile.name)
  //         // console.log('pais: ', profile.country)
  //         // console.log('imagen: ', profile.image)
  //         // console.log('nº semillas: ', item.seeds.length)
  //         console.log('semillas: ', JSON.stringify(item.seeds))
  //         var newSeeds = []
  //         var seedsChanged = false
  //         for (let j = 0; j < item.seeds.length; j++) {
  //           const seedId = item.seeds[j]
  //           const seed = (await firebase.firestore.collection('reserves').doc('bIChzCan1TvVvhJYdYdX').collection('seeds').doc(seedId).get()).data()

  //           // console.log('seed: ', seed)
  //           // console.log('seed.ownerId: ', seed.ownerId)
  //           if (!seed.ownerId) {
  //             //Guardala
  //             console.log('seed not asigned: ', seedId)
  //             notSeeds.push(seedId)
  //             const response = await firebase.firestore.collection('reserves').doc('bIChzCan1TvVvhJYdYdX').collection('seeds').doc(seedId).update({ownerId: item.userId})
  //             console.log('Guardado: ', response)
  //           } else {
  //             if (seed.ownerId == item.userId) {
  //               console.log('seed asigned to user!!!')
  //               newSeeds.push(seedId)
  //             } else {
  //               seedsChanged = true
  //               console.log('seed asigned to other user: ', seed.ownerId)
  //               const newSeed = emptySeeds[addedSeeds.length].id
  //               addedSeeds.push(newSeed)
  //               newSeeds.push(newSeed)
  //               var seedObj = {tranSeed: seedId, newSeed: newSeed, user: item.userId, ownerId: seed.ownerId, transaction: item.id}
  //               seeds.push(seedObj)
  //             }
  //           }
  //         }
  //         if (seedsChanged) {
  //           console.log('nuevas semillas: ', JSON.stringify(newSeeds))
  //           const response = await firebase.firestore.collection('transactions').doc(item.id).update({seeds: newSeeds})
  //           console.log('Guardado: ', response)
  //         }
  //         console.log('\n\n')
  //       }
  //     }
  //     console.log('not assigned seed: ', JSON.stringify(notSeeds))
  //     console.log('Assigned to other user: ', JSON.stringify(seeds, null, 2))
  //   },
  //   async setSeedsToUser(seeds, uid) {
  //     var promises = []
  //     seeds.forEach(async seedId => {
  //       promises.push(firebase.firestore.collection('reserves').doc('bIChzCan1TvVvhJYdYdX').collection('seeds').doc(seedId).update({ownerId: this.userId}))
  //     });
  //     const response = await Promise.all(promises)
  //   }
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Transactions.vue